module.exports = __webpack_public_path__ + "static/media/vegitables_73.c51053ff.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_73.csv
// module id = 661
// module chunks = 0